import { useEffect, useRef, useCallback } from "react";
import { useTrainingStore } from "../stores/trainingStore";
import { calculateTotalDistance } from "../utils/distance";

export const useGeolocation = () => {
  const watchIdRef = useRef<number | null>(null);
  const { isActive, isPaused, addPosition, updateDistance, positions } =
    useTrainingStore();

  const startWatching = useCallback(() => {
    if (!navigator.geolocation) {
      console.error("Geolocation not supported");
      return;
    }

    watchIdRef.current = navigator.geolocation.watchPosition(
      (position) => {
        const newPos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          timestamp: Date.now(),
        };
        addPosition(newPos);
      },
      (error) => console.error("Geolocation error:", error),
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 5000,
      },
    );
  }, [addPosition]);

  const stopWatching = useCallback(() => {
    if (watchIdRef.current !== null) {
      navigator.geolocation.clearWatch(watchIdRef.current);
      watchIdRef.current = null;
    }
  }, []);

  useEffect(() => {
    if (isActive && !isPaused) {
      startWatching();
    } else {
      stopWatching();
    }

    return () => stopWatching();
  }, [isActive, isPaused, startWatching, stopWatching]);

  useEffect(() => {
    const distance = calculateTotalDistance(positions);
    updateDistance(distance);
  }, [positions, updateDistance]);

  return { positions };
};
